<div *ngIf="loading" class="lds-dual-ring {{size}}"></div>